module.exports = __webpack_public_path__ + "img/story2.33b25472.png";